var _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuwaySymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-90 -90 180 180",
    role: "img",
    "aria-label": "NUWAY symbol",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NUWAY symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#30251F",
    strokeWidth: 18,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M-40.2 73.72C-58.2 60.72 -68.2 46.72 -68.2 19.72L-68.2 -23.28A46.5 46.5 0 0 1 24.8 -23.28L24.8 19.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M-21.2 -22.28L-21.2 23.49A43.73 43.73 0 0 0 66.25 23.49L66.25 -23.28C66.25 -29.28 65.75 -33.28 64.25 -39.28"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    cx: 63.75,
    cy: -63.28,
    r: 14.5,
    fill: "#F5C400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuwaySymbol);
export default __webpack_public_path__ + "static/media/nuway-symbol.e8da8fab53162f9e002e976b98b5fc43.svg";
export { ForwardRef as ReactComponent };